import React from 'react';

import AdminLayout from '../../components/AdminLayout';
import Customers from './Customers';

const CustomersPage = () => {
    return (
        <AdminLayout>
            <Customers />
        </AdminLayout>
    );
};

export default CustomersPage;
